import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { Activity, ActivityService } from '../shared/services/activity.service';

@Component({
  selector: 'app-activity',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss'
})
export class ActivityComponent {
  private activityService = inject(ActivityService);
  public activities: Activity[] = [];
  loading = true;

  constructor() {
    this.activityService.getActivities(false).subscribe(activities => {
      this.activities = activities;
      this.loading = false;
    });
  }
}
